import Vue from 'vue'
import Vuex from 'vuex'

import { AxiosResponse } from 'axios'
import Notifications from '@/store/notifications/notifications'
import { CatalogItemsLinkerApiRequest, CatalogItemsLink, CatalogItemsLinks, LinkedItem } from './catalogItemsLinkerApiRequestHelper'

Vue.use(Vuex)

export interface CatalogItemsLinkerState {
    dataLoading: boolean,
    context: string,
    instanceId: string,
    mainCatalogId: string,
    mainCatalogItemId: string,
    subCatalogId: string,
    linkedIds: Array<string>,
    linkedProducts: Object,
}

const getInitialState = (): CatalogItemsLinkerState => ({
    dataLoading: true,
    context: '',
    instanceId: '',
    mainCatalogId: '',
    mainCatalogItemId: '',
    subCatalogId: '',
    linkedIds: [],
    linkedProducts: {},
})

export default new Vuex.Store({
  state: getInitialState(),
  mutations: {
    setContext(state: CatalogItemsLinkerState, context: string) {
      state.context = context
    },
    setInstanceId(state: CatalogItemsLinkerState, instanceId: string) {
      state.instanceId = instanceId
    },
    setMainCatalogId(state: CatalogItemsLinkerState, mainCatalogId: string) {
      state.mainCatalogId = mainCatalogId
    },
    setMainCatalogItemId(state: CatalogItemsLinkerState, mainCatalogItemId: string) {
      state.mainCatalogItemId = mainCatalogItemId
    },
    setSubCatalogId(state: CatalogItemsLinkerState, subCatalogId: string) {
      state.subCatalogId = subCatalogId
    },
    setLinkedIds(state: CatalogItemsLinkerState, ids: Array<string>) {
      state.linkedIds = ids
    },
    setLinkedProducts(state: CatalogItemsLinkerState, products: Object) {
      state.linkedProducts = {}
      state.linkedIds = []
      for(const [key, value] of Object.entries(products)){
        state.linkedIds.push(key)
        state.linkedProducts[key as keyof typeof state.linkedProducts] = value
      }
    },
    addLinkedItem(state: CatalogItemsLinkerState, item: any) {
      state.linkedIds.push(item.id)
      state.linkedProducts[item.id as keyof typeof state.linkedProducts] = item
    },
    removeLinkedItem(state: CatalogItemsLinkerState, id: any) {
      if(state.linkedIds.includes(id)){
        state.linkedIds.splice(state.linkedIds.indexOf(id), 1)
        delete state.linkedProducts[id as keyof typeof state.linkedProducts]
      }
    },
    setDataLoading(state: CatalogItemsLinkerState, dataLoading: boolean) {
        state.dataLoading = dataLoading
    }
  },
  actions: {
    linkItems(context: any, item: any) {
            
      const storeResponse = CatalogItemsLinkerApiRequest.linkItems({
        context: context.state.context,
        instanceId: context.state.instanceId,
        mainCatalogId: context.state.mainCatalogId,
        mainCatalogItemId: context.state.mainCatalogItemId,
        subCatalogId: context.state.subCatalogId,
        subCatalogItemId: item.id,
      })

      return storeResponse
        .then((response: AxiosResponse<CatalogItemsLinks>) => {
          if (response.status !== 200) {
            throw Error('Status code is not 200')
          }
          context.commit('addLinkedItem', item)
          return response
        })
        .catch(error => {
          Notifications.commit('addError', Error('catalogItemsLinker.linkError'), { root: true })
          throw error
        })
    },
    detachItems(context: any, itemId: string) {
            
      const storeResponse = CatalogItemsLinkerApiRequest.detachItems({
        context: context.state.context,
        instanceId: context.state.instanceId,
        mainCatalogId: context.state.mainCatalogId,
        mainCatalogItemId: context.state.mainCatalogItemId,
        subCatalogId: context.state.subCatalogId,
        subCatalogItemId: itemId,
      })

      return storeResponse
        .then((response: AxiosResponse<CatalogItemsLinks>) => {
          if (response.status !== 200) {
            throw Error('Status code is not 200')
          }
          context.commit('removeLinkedItem', itemId)
          return response
        })
        .catch(error => {
          Notifications.commit('addError', Error('catalogItemsLinker.linkError'), { root: true })
          throw error
        })
    },
    getLinkedIds(context: any) {
        CatalogItemsLinkerApiRequest.getLinkedItemsIds(context.state.context, context.state.instanceId, context.state.mainCatalogItemId).then(results => {
            context.commit('setLinkedIds', results.data.data)
            context.commit('setDataLoading', false)
        })
    },
    getLinkedItems(context: any) {
        CatalogItemsLinkerApiRequest.getLinkedItems(context.state.context, context.state.instanceId, context.state.subCatalogId, context.state.mainCatalogItemId).then(results => {
            context.commit('setLinkedProducts', results.data.data)
            context.commit('setDataLoading', false)
        })
    },
    getAllLinkedIds(context: any) {
        CatalogItemsLinkerApiRequest.getAllLinkedItemsIds(context.state.context, context.state.instanceId).then(results => {
            context.commit('setLinkedIds', results.data.data)
            context.commit('setDataLoading', false)
        })
    },
  }
})
